import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans, withTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Collapse from "@material-ui/core/Collapse";
import InputLabel from "@material-ui/core/InputLabel";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import IconPicker from "../IconPicker";
import FilterWrapper from "../filter/FilterWrapper";
import axios from "../../AxiosClient";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import ActionButton from "../ActionButton";
import PropertyNames from "../../PropertyNames";
import KpsTextField from "../KpsTextField";
const styles = (theme) => ({
  dialog: {
    //minWidth: 700,
  },
  iconTitleWrapper: {
    display: "flex",
    "& > *": {
      marginLeft: 10,
      marginRight: 10,
      flexGrow: 1,
    },
  },
  filterContainer: {
    marginTop: 25,
  },
  titleTypeControl: {
    marginTop: 9,
  },
  iconButton: {
    marginTop: 25,
  },
  iconSpacing: {
    marginLeft: theme.spacing(1),
  },
});

const typeToFilter = {
  document: "FilterDocuments",
  discussion: "FilterDiscussions",
  search: "FilterSearches",
  graph: "",
  entry: "FilterEntries",
  list: "FilterUserList",
  knowledgeitem: "FilterKnowledgeItems",
  content: "FilterKnowledgeItems",
  report: "FilterReports",
};

export class CreatePortletDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    layoutId: PropTypes.number.isRequired,
  };

  state = {
    title: "",
    portletDescription: "",
    icon: "assessment",
    type: "document",
    portletFilterObject: {},
    listDisplayAllLists: false,
    createNewList: false,
    listDisplay: "new",
    selectedList: "",
    iconPicker: false,
    filters: {},
    userLists: [],
    existingList: null,
    filterInstance: new Date().getTime().toString(),
    saving: false,
  };

  componentDidMount() {
    if (this.props.portlet != null) {
      this.setState({
        icon: this.props.portlet.icon,
        title: this.props.portlet.title,
        portletDescription: this.props.portlet.portletDescription,
      });
      this.findTypeFromPortlet(this.props.portlet);
    }
    this.getUserLists();
  }

  getUserLists = () => {
    axios.post("/userlist/list/", { withCredentials: true }).then((res) => {
      this.setState({ userLists: res.data.content });
    });
  };
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.dialog }}
        >
          <DialogTitle id="alert-dialog-title">
            {this.props.addPortlet ? (
              <Trans i18nKey="create_portlet_header" />
            ) : (
              <Trans i18nKey="list_header_edit_portlet" />
            )}
          </DialogTitle>
          <DialogContent>
            <>
              <div
                className={classes.iconTitleWrapper}
                style={{ display: "flex" }}
              >
                <FormControl
                  className={classes.titleTypeControl}
                  style={{ flex: 3 }}
                >
                  <KpsTextField
                    id="title-input"
                    aria-label="title-input"
                    ariaLabel="title-input"
                    label={this.props.t("create_portlet_title")}
                    required
                    className={classes.textField}
                    value={this.state.title}
                    onChange={this.changeName}
                    error={!!this.state.nameErrorText}
                    helperText={this.state.nameErrorText}
                  />
                </FormControl>
                <FormControl
                  className={classes.titleTypeControl}
                  style={{ flex: 5 }}
                >
                  <KpsTextField
                    id="outlined-description"
                    label={this.props.t("create_portlet_description")}
                    required
                    className={classes.textField}
                    value={this.state.portletDescription}
                    onChange={this.changeDescription}
                    error={!!this.state.nameErrorText}
                    helperText={this.state.nameErrorText}
                  />
                </FormControl>
              </div>
              <div style={{ display: "flex" }}>
                <FormControl style={{ marginRight: 20, flex: 2 }}>
                  <Button
                    variant="outlined"
                    className={classes.iconButton}
                    onClick={this.openIconPicker}
                  >
                    <Trans i18nKey="create_portlet_portlet_icon" />
                    <span style={{ marginLeft: 5 }} className="material-icons">
                      {this.state.icon}
                    </span>
                  </Button>
                </FormControl>
                {this.props.addPortlet && (
                  <FormControl
                    className={classes.titleTypeControl}
                    style={{ flex: 2, marginRight: 20 }}
                  >
                    <InputLabel htmlFor="type">
                      <Trans i18nKey="create_portlet_type" />
                    </InputLabel>
                    <Select
                      value={this.state.type}
                      onChange={this.handleTypeChange}
                      inputProps={{
                        name: "type",
                        id: "type",
                      }}
                    >
                      <MenuItem value="document">
                        <Trans i18nKey="global_document" />
                      </MenuItem>
                      <MenuItem value="content">
                        <Trans i18nKey="global_content" />
                      </MenuItem>
                      {this.props.applicationProperties[
                        PropertyNames.DISCUSSIONS_ENABLED
                      ] === "true" && (
                        <MenuItem value="discussion">
                          <Trans i18nKey="global_discussion" />
                        </MenuItem>
                      )}
                      <MenuItem value="search">
                        <Trans i18nKey="global_search" />
                      </MenuItem>
                      <MenuItem value="entry">
                        <Trans i18nKey="global_entry" />
                      </MenuItem>
                      <MenuItem value="list">
                        <Trans i18nKey="portlet_list_of_items" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              </div>
              {this.state.type === "list" && (
                <div style={{ display: "flex", marginTop: 10 }}>
                  <FormControl component="fieldset" style={{ flex: 1 }}>
                    <FormLabel component="legend">List display</FormLabel>
                    <RadioGroup
                      aria-label="list-display"
                      name="listdisplay"
                      value={this.state.listDisplay}
                      onChange={(e) =>
                        this.setState({ listDisplay: e.target.value })
                      }
                    >
                      <FormControlLabel
                        value="new"
                        label="Create new list"
                        control={<Radio />}
                      />
                      <FormControlLabel
                        value="all"
                        label="Display all lists"
                        control={<Radio />}
                      />
                      <FormControlLabel
                        value="one"
                        label="Display an existing list"
                        control={<Radio />}
                      />
                    </RadioGroup>
                  </FormControl>
                  <Collapse
                    in={this.state.listDisplay === "one"}
                    style={{ flex: 1 }}
                  >
                    <KpsTextField
                      id="existing-lists"
                      style={{ width: "100%" }}
                      label="Pick an existing list"
                      select
                      value={this.state.existingList}
                      onChange={(e) =>
                        this.setState({ existingList: e.target.value })
                      }
                    >
                      {this.state.userLists.map((list, idx) => {
                        return (
                          <MenuItem value={list.id} key={idx}>
                            {list.title}
                          </MenuItem>
                        );
                      })}
                    </KpsTextField>
                  </Collapse>
                </div>
              )}
              {this.props.addPortlet && (
                <div className={classes.filterContainer}>
                  <FilterWrapper
                    open={true}
                    filterElement={typeToFilter[this.state.type]}
                    filter={this.state.filters}
                    onFilterChange={this.onFilterChange}
                    isFilterBar={false}
                    title=""
                    showReset={false}
                    resetToDefaultFilters={this.resetToDefaultFilters}
                    filterInstance={this.state.filterInstance}
                  />
                </div>
              )}
            </>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} color="primary">
              <Trans i18nKey="global_cancel" />
            </Button>
            <ActionButton
              loading={this.state.saving}
              onClick={
                this.props.addPortlet ? this.handleSubmit : this.editPortlet
              }
              color="primary"
              autoFocus
            >
              {this.props.addPortlet ? (
                <Trans i18nKey="global_create" />
              ) : (
                <Trans i18nKey="global_update" />
              )}
            </ActionButton>
          </DialogActions>
        </Dialog>
        <IconPicker
          open={this.state.iconPicker}
          onPick={this.handleIconChange}
          handleClose={this.handleClose}
        />
      </div>
    );
  }

  resetToDefaultFilters = () => {
    this.setState({ filters: {} });
  };

  onFilterChange = (filters) => {
    this.setState({ filters });
  };

  handleSubmit = () => {
    if (!this.state.title) {
      this.setState({ nameErrorText: this.props.t("global_required") });
      return;
    }
    let type = "CardList";
    let objectClass = "com.kpsol.api.apicommon.document.DocumentInterface";
    switch (this.state.type) {
      case "report":
        objectClass = "com.kpsol.api.apicommon.document.ReportInterface";
        break;
      case "content":
        objectClass = "com.kpsol.api.apicommon.content.KnowledgeItemInterface";
        break;
      case "discussion":
        objectClass =
          "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface";
        break;
      case "search":
        // objectClass = "com.kpsol.api.apicommon.search.SearcherInterface";
        objectClass = "com.kpsol.api.apicommon.history.SearchHistoryInterface";
        break;
      case "entry":
        objectClass = "com.kpsol.api.apicommon.discussions.EntryInterface";
        break;
      case "list":
        if (this.state.listDisplay === "new") {
          this.createNewList();
          return;
        } else if (this.state.listDisplay === "all") {
          objectClass = "com.kpsol.api.apicommon.list.ListUserListsInterface";
        } else if (this.state.listDisplay === "one") {
          objectClass = "com.kpsol.api.apicommon.list.UserListInterface";
          this.savePortlet(type, objectClass, {
            listID: this.state.existingList,
          });
          return;
        }

        break;
      default:
        break;
    }
    this.savePortlet(type, objectClass);
  };

  savePortlet = (type, objectClass, parameters) => {
    let portlet = {
      title: this.state.title,
      portletDescription: this.state.portletDescription,
      icon: this.state.icon,
      parameters: parameters
        ? JSON.stringify(parameters)
        : JSON.stringify(this.state.filters),
      elementType: type,
      instance: new Date().getTime(),
      objectClass: objectClass,
    };
    axios
      .post(`/portalLayout/${this.props.currentLayout.id}/portlet/`, {
        ...portlet,
      })
      .then((res) => {
        this.setState({ saving: false });
        this.props.handleSubmit(res.data);
      })
      .catch((err) => {
        this.setState({ saving: false });
      });
  };

  createNewList = () => {
    axios
      .post("/userlist/", {
        title: this.state.title,
        listItems: [],
      })
      .then((res) => {
        this.savePortlet(
          "CardList",
          "com.kpsol.api.apicommon.list.UserListInterface",
          { listID: res.data.id }
        );
      });
  };

  changeName = (e) => {
    if (!e) {
      this.setState({ nameErrorText: this.props.t("global_required") });
    } else {
      this.setState({ title: e.target.value });
    }
  };

  changeDescription = (e) => {
    if (!e) {
      this.setState({ nameErrorText: this.props.t("global_required") });
    } else {
      this.setState({ portletDescription: e.target.value });
    }
  };

  handleIconChange = (e) => {
    this.setState({ icon: e });
  };

  openIconPicker = () => {
    this.setState({ iconPicker: true });
  };
  handleClose = () => {
    this.setState({ iconPicker: false });
  };

  handleTypeChange = (e) => {
    this.setState({ type: e.target.value });
  };

  findTypeFromPortlet = (portlet) => {
    let type = "";
    switch (portlet.objectClass) {
      case "com.kpsol.api.apicommon.document.DocumentInterface":
      case "com.kpsol.api.apicommon.document.ReportInterface":
        type = "document";
        break;
      case "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface":
        type = "discussion";
        break;
      //case "com.kpsol.api.apicommon.search.SearcherInterface":
      case "com.kpsol.api.apicommon.history.SearchHistoryInterface":
        type = "searchhistory";
        break;
      case "CardGraph":
        type = "graph";
        break;
      case "com.kpsol.api.apicommon.discussions.EntryInterface":
        type = "entry";
        break;
      case "com.kpsol.api.apicommon.list.ListUserListsInterface" ||
        "com.kpsol.api.apicommon.list.UserListInterface":
        type = "list";
        break;

      default:
        break;
    }

    this.setState({ type: type });
  };

  editPortlet = () => {
    this.setState({ saving: true });
    if (this.state.title && this.state.title !== "") {
      if (this.state.type === "list") {
        axios.post(`/userlist/${this.props.portlet.parameters.listID}`, {
          title: this.state.title,
        });
      }

      let portlet = this.props.portlet;
      portlet.title = this.state.title;
      portlet.portletDescription = this.state.portletDescription;
      portlet.parameters = JSON.stringify(this.state.portletFilterObject);
      portlet.icon = this.state.icon;
      axios
        .patch(
          `/portalLayout/${portlet.portalLayoutID}/portlet/${portlet.id}`,
          {
            ...portlet,
          }
        )
        .then(() => {
          this.props.onClose();
          this.setState({ saving: false });
        })
        .catch(() => {
          this.setState({ saving: false });
        });
    }
  };
}
const mapStateToProps = (state) => ({
  canEdit: state.layout.edit,
  currentLayout: state.layout.currentLayout,
  applicationProperties: state.setting.applicationProperties,
});
export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withTranslation()(CreatePortletDialog)));
